// extracted by mini-css-extract-plugin
export var drawerContent = "_3l-0";
export var valueBlock = "_3l-1";
export var valueBlockFrom = "_3l-2 _3l-1";
export var valueBlockTo = "_3l-3 _3l-1";